import { TenantContext } from '../models/types';

export const getAccessPathLabel = (tenant?: TenantContext): string => {
  if (!tenant) {
    return 'Resolving access';
  }
  if (tenant.authority?.isCustomerAdmin) {
    if (tenant.authority.customerAuthorityReason === 'permissions_baseline_admin') {
      return 'Customer system admin';
    }
    if (tenant.authority.customerAuthorityReason === 'subscription_contact') {
      return 'Subscription contact admin';
    }
    return 'Customer admin';
  }
  if (tenant.authority?.isStaffAdmin) {
    return 'Edinshall staff admin';
  }
  return 'Customer user';
};

export const getAccessPathDescription = (tenant?: TenantContext): string => {
  if (!tenant) {
    return 'The portal is still resolving your access rights.';
  }
  if (tenant.authority?.isCustomerAdmin) {
    if (tenant.authority.customerAuthorityReason === 'permissions_baseline_admin') {
      return 'You are listed as a customer system admin in the tenant permissions policy.';
    }
    if (tenant.authority.customerAuthorityReason === 'subscription_contact') {
      return 'You are the activated subscription contact for this licensed tenant scope.';
    }
    return 'You have customer-admin access for this licensed tenant scope.';
  }
  if (tenant.authority?.isStaffAdmin) {
    return 'You are using an Edinshall staff/admin role path.';
  }
  return 'You have base customer access. Admin controls are hidden unless a customer system admin grants them.';
};
